import { FC } from "react";
import {
  CircleDollarSignIcon,
  Clock5Icon,
  LockKeyholeIcon,
} from "lucide-react-native";

import PointCareSmallLogo from "@/assets/images/favicon.png";
import { VnBox } from "@/components/VnBox";
import { VnImage } from "@/components/VnImage";
import { OnboardingScreenType } from "@/domain/onboarding";
import { useOnboardingBenefitsContent } from "@/hooks/useOnboardingBenefitsContent";

import { IconAndText } from "./IconAndText";
import { OnboardingHeader } from "./OnboardingHeader";
import { OnboardingStepFrame } from "./OnboardingStepFrame";

export const OnboardingBenefitsStep: FC<OnboardingScreenType> = layout => {
  const { title, description, firstItem, freeToUse, infoIsPrivate } =
    useOnboardingBenefitsContent();

  return (
    <OnboardingStepFrame {...layout}>
      <VnBox className="bg-background w-full flex-1 items-center px-6 pt-16">
        <VnBox className="gap-6 md:max-w-screen-sm">
          <OnboardingHeader
            iconComponent={
              <VnImage
                source={PointCareSmallLogo}
                className="h-12 w-12"
                contentFit="contain"
              />
            }
            titleI18nKey={title.i18nKey}
            titleI18nOptions={title.i18nOptions}
            descriptionI18nKey={description.i18nKey}
          />

          <VnBox className="flex flex-col gap-4">
            <IconAndText
              icon={Clock5Icon}
              textI18nKey={firstItem.i18nKey}
              textI18nOptions={firstItem.i18nOptions}
              iconClassName="text-muted-foreground"
            />
            <IconAndText
              icon={CircleDollarSignIcon}
              textI18nKey={freeToUse.i18nKey}
            />
            <IconAndText
              icon={LockKeyholeIcon}
              textI18nKey={infoIsPrivate.i18nKey}
              iconClassName="text-sidebar"
            />
          </VnBox>
        </VnBox>
      </VnBox>
    </OnboardingStepFrame>
  );
};
